import { BrowserRouter, Routes, Route } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

import ScrollToTop from "./components/ScrollToTop";

import Navbar from "./components/navbar";
import Footer from "./components/footer";

import Home from "./pages/home";
import About from "./pages/about";
import Services from "./pages/services";
import Products from "./pages/products";
import Hearing from "./pages/hearing";
import Location from "./pages/location";
import Contact from "./pages/contact";
import Gallery from "./pages/gallery";

function App() {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out",
    });
  }, []);

  return (
    <BrowserRouter>

      <ScrollToTop />

      <div className="app">

        <Navbar />

        <main className="main-content page-wrapper">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/products" element={<Products />} />
            <Route path="/hearing" element={<Hearing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/location" element={<Location />} />
            <Route path="/gallery" element={<Gallery />} />
          </Routes>
        </main>

        <Footer />

      </div>

      <div
        className="elfsight-app-c8130f44-f62c-4aa3-848a-7cc366e02f9d"
        data-elfsight-app-lazy
      ></div>

    </BrowserRouter>
  );
}

export default App;